import React from 'react';
import FormProvider from "./FormContext";
import { AuthProvider } from "./AuthContext";
import { BrokerProvider } from "./BrokerContext";
import { SidebarProvider } from "./SideBarContext";
import { FabProvider } from "./FabContext";
import { TransferenciaCustodiaProvider } from "./TransferenciaCustodiaContext";
import { CarteiraProvider } from './CarteiraContext';

const ContextWrapper: React.FC = ({ children }) => {
  return (
    <FabProvider>
      <AuthProvider>
        <BrokerProvider>
          <TransferenciaCustodiaProvider>
            <CarteiraProvider>
              <SidebarProvider>
                <FormProvider>{children}</FormProvider>
              </SidebarProvider>
            </CarteiraProvider>
          </TransferenciaCustodiaProvider>
        </BrokerProvider>
      </AuthProvider>
    </FabProvider>
  );
};

export default ContextWrapper;
